import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssessorAssignmentsState } from '../reducers/assessor-assignments.reducer';
import { ASSESSOR_ASSIGNMENTS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<AssessorAssignmentsState>(ASSESSOR_ASSIGNMENTS_FEATURE_KEY);

export const selectAssignments = createSelector(selectState, (state) => state.assignments);
export const selectLoaded = createSelector(selectState, (state) => state.loaded);
export const selectLoading = createSelector(selectState, (state) => state.loading);
export const selectSaving = createSelector(selectState, (state) => state.saving);
export const selectSaved = createSelector(selectState, (state) => state.saved);
export const selectError = createSelector(selectState, (state) => state.error);

export const selectSchools = createSelector(selectState, (state) => state.schools);
export const selectSchoolsLoaded = createSelector(selectState, (state) => state.schoolsLoaded);
export const selectSchoolsLoading = createSelector(selectState, (state) => state.schoolsLoading);

export const selectCourses = createSelector(selectState, (state) => state.courses);
export const selectCoursesLoaded = createSelector(selectState, (state) => state.coursesLoaded);
export const selectCoursesLoading = createSelector(selectState, (state) => state.coursesLoading);

export const selectPackages = createSelector(selectState, (state) => state.packages);
export const selectPackagesLoaded = createSelector(selectState, (state) => state.packagesLoaded);
export const selectPackagesLoading = createSelector(selectState, (state) => state.packagesLoading);
